import { ModelBase } from 'store/model-base';

export class CmsLevelMoveSuccess extends ModelBase {
    public static storeName: string = 'cmsLevelMoveSuccess';

    public pageTitle: string;
    public header: string;
    public subhead: string;
    public cta: string;
    public fiveGIcon: CmsMediaImage;
}
